import { render, staticRenderFns } from "./Entities.vue?vue&type=template&id=498f233c&scoped=true"
import script from "./Entities.vue?vue&type=script&lang=js"
export * from "./Entities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498f233c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('498f233c')) {
      api.createRecord('498f233c', component.options)
    } else {
      api.reload('498f233c', component.options)
    }
    module.hot.accept("./Entities.vue?vue&type=template&id=498f233c&scoped=true", function () {
      api.rerender('498f233c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Graph/Entities.vue"
export default component.exports